import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Spin } from 'antd'
import MyRadio from '../../../components/forms/radio'
import MyTextArea from '../../../components/forms/textArea'

const AlumniOrganizationJoinAudit = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({
    status: props.data.status,
    failureReason: props.data.failureReason
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleOk = () => {
    setIsLoading(true)
    axios.post('/p/alumni/organization_member_application/audit', { 
      merchant_oid: merchantOid, 
      appointment_oid: props.data.oid,
      status: formValue.status,
      failure_reason: formValue.failureReason
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('审核完成！')
          props.isCancel()
          props.getAppointmentDetail()
          props.getAppointmentData()
          setIsLoading(false)
        } else {
          message.error(response.msg)
          setIsLoading(false)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title="审核"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okText="保存">

      <Spin spinning={isLoading} tip='审核中，请稍等'>
        <MyRadio
          id='status'
          label='请选择'
          options={[
            {
              label: '未审核',
              value: 1,
            },
            {
              label: '通过',
              value: 2,
            },
            {
              label: '拒绝',
              value: 3,
            }
          ]}
          value={formValue.status}
          onChange={setFormValue}
        />

        {formValue.status === 3 && <MyTextArea 
          id="failureReason"
          label='拒绝原因'
          minRows={3}
          placeholder='请输入拒绝原因'
          value={formValue.failureReason}
          onChange={setFormValue}
        />}
      </Spin>
    </Modal>
  )
}

export default AlumniOrganizationJoinAudit
